import React, { Component } from 'react'
import { Typography } from '@material-ui/core'
import RightSidebar from './RightSidebar'
import './data-browser.scss'
import Filters from './Content/Filters'
import Charts from './Content/Charts'

// TODO start task/ delete after finishing
class MonitorsAndAlerts extends Component {
  state = {
    areChartsCombined: false,
  }

  onSwitchSplitCharts = (condition = false) => {
    if (condition) {
      return this.setState({ areChartsCombined: false })
    }

    this.setState(prevState => ({
      areChartsCombined: !prevState.areChartsCombined,
    }))
  }

  render() {
    const { areChartsCombined } = this.state

    return (
      <div className="module db-module">
        <div className="module-head">
          <Typography className="module-title" variant="h5">
            {this.props.currentApp.name}
          </Typography>
          <div className="module-filter">
            <Filters />
          </div>
        </div>
        <div className="module-content db-main">
          <Charts combineCharts={areChartsCombined} />
          <RightSidebar
            combineCharts={areChartsCombined}
            switcher={this.onSwitchSplitCharts}
          />
        </div>
      </div>
    )
  }
}

export default MonitorsAndAlerts
